import { TEXT_COLOR } from "@hl/base-components/lib/theme/colors";
import { Anchor, Group, Text } from "@mantine/core";

import { TOOLS_CDN_URL } from "~/config";

export const EmbedPreview = ({ code }: { code: string }) => {
  const url = `${TOOLS_CDN_URL}/embed-preview.html?code=${encodeURIComponent(
    code
  )}`;
  return (
    <>
      <iframe
        src={url}
        style={{
          width: "100%",
          height: "800px",
          border: "none",
        }}
      ></iframe>
      <Group pt="md" position="center">
        <Text color={TEXT_COLOR.SECONDARY} size="sm">
          Embed preview
        </Text>
        <Anchor href={url} target="_blank">
          <Text color={TEXT_COLOR.SECONDARY} size="sm">
            Open in new tab
          </Text>
        </Anchor>
      </Group>
    </>
  );
};
